import { itDate } from "@/lib/download";

export const EVENT_TYPES = ["Sagra", "Fiera", "Congresso", "Evento di piazza", "Evento al chiuso", "Concerto", "Serata quiz", "Evento a tema", "Altro"];
export const THEMES = ["Fluo party", "Schiuma party", "Holi party"];
export const STAND_SIZES = ["1x1", "2x1", "2x2", "3x2"];
export const SIZES = { small: "Piccolo", medium: "Medio", large: "Grande" };
export const EXHIBITORS = { prodotti: "Espositori di prodotti", alimenti: "Vendita alimenti" };

const CIRCUS = "Artisti circensi e di strada";
export const STREET = [
  { label: "Trampolieri", macro: CIRCUS, wants: ["trampol"] },
  { label: "Maghi/Illusionisti", macro: "Comicità e varietà", wants: ["prestigiat", "illusion", "magh"] },
  { label: "Mimo", macro: CIRCUS, wants: ["mim"] },
  { label: "Giocolieri", macro: CIRCUS, wants: ["giocolier"] },
  { label: "Sputafuoco", macro: CIRCUS, wants: ["fuoco"] },
  { label: "Fachiri", macro: CIRCUS, wants: ["fachir"] },
  { label: "Sand Artist", macro: "Arti visive e creatività dal vivo", wants: ["sand"] },
];
const BAND = "Gruppi musicali e band";
const ORCH = "Orchestre, cori e bande";
export const MUSICIANS = [
  { label: "Cover band", macro: BAND, wants: ["cover"] },
  { label: "Orchestra", macro: ORCH, wants: ["orchestra"] },
  { label: "Solisti", macro: "Musicisti e strumentisti", wants: [] },
  { label: "Gruppo jazz", macro: BAND, wants: ["jazz"] },
  { label: "Coro gospel", macro: ORCH, wants: ["coro", "gospel"] },
  { label: "Banda musicale", macro: ORCH, wants: ["banda"] },
];
export const THEATRE = ["Commedia", "Tragedia", "Monologo", "Altro"];
const KIDS_MACRO = "Spettacoli per bambini e famiglie";
export const KIDS = [
  { label: "Animazione base", area: "artist", macro: KIDS_MACRO, wants: ["animazion"] },
  { label: "Mascotte", area: "artist", macro: KIDS_MACRO, wants: ["mascott"] },
  { label: "Gonfiabili", area: "supplier", macro: "Attrazioni e servizi specialistici", wants: ["gonfiabil"] },
];
export const OTHER_PH = "Non trovi quello che cerchi? Scrivilo qui";

export const EMPTY = {
  eventType: "", eventTypeOther: "", theme: "", place: null, venue: "", dateMode: "single", date: "", range: null,
  stands: null, standSizes: [], standCount: "", exhibitors: null, exhibitorsKind: "", foodTruck: null, stage: null, stageSqm: "",
  street: null, streetCounts: {}, audio: null, audioPeople: "", lights: null, lightsSize: "", musicians: null, musicianKinds: [],
  theatre: null, theatreKinds: [], theatreOther: "", kids: null, kidsKinds: [], comedy: null, dj: null, photographer: null, videomaker: null,
  plan: null, attachment: null, other: "", notes: {},
};

export const eventTypeLabel = (a) => (a.eventType === "Altro" ? a.eventTypeOther.trim() : a.eventType);
export const dates = (a) => (a.dateMode === "single" ? { date: a.date, dateTo: a.date } : { date: a.range?.from || "", dateTo: a.range?.to || "" });
const streetOn = (a) => STREET.filter((s) => (parseInt(a.streetCounts[s.label]) || 0) > 0);

export function toCategories(a) {
  const out = {};
  const add = (area, macro, wants = []) => { const k = `${area}|${macro}`; out[k] = { area, macro, wants: [...new Set([...(out[k]?.wants || []), ...wants])] }; };
  if (a.stands) { add("supplier", "Noleggio attrezzature", ["stand", "gazebo"]); }
  if (a.foodTruck) { add("supplier", "Catering, bar e somministrazione", ["food truck", "street food"]); }
  if (a.stage) { add("supplier", "Palchi, strutture e scenotecnica", ["palc", "pedan"]); }
  if (a.street) { streetOn(a).forEach((s) => add("artist", s.macro, s.wants)); }
  if (a.audio) { add("supplier", "Service audio e fonica"); }
  if (a.lights) { add("supplier", "Service luci e illuminotecnica"); }
  if (a.musicians) { MUSICIANS.filter((m) => a.musicianKinds.includes(m.label)).forEach((m) => add("artist", m.macro, m.wants)); }
  if (a.theatre) { add("artist", "Teatro e recitazione", a.theatreKinds.includes("Monologo") ? ["monolog"] : ["compagni", "attor"]); }
  if (a.kids) { KIDS.filter((k) => a.kidsKinds.includes(k.label)).forEach((k) => add(k.area, k.macro, k.wants)); }
  if (a.comedy) { add("artist", "Comicità e varietà", ["comic", "cabaret"]); }
  if (a.dj) { add("artist", "DJ e musica elettronica"); }
  if (a.photographer) { add("supplier", "Fotografia e produzione contenuti", ["foto"]); }
  if (a.videomaker) { add("supplier", "Video, TV e streaming", ["video"]); }
  return Object.values(out);
}

export function toBrief(a) {
  return {
    eventTypeDetail: a.eventType === "Evento a tema" ? a.theme.trim() || null : null,
    venue: a.venue.trim() || null,
    stands: a.stands ? { sizes: a.standSizes, count: parseInt(a.standCount) } : null,
    exhibitors: a.exhibitors && a.exhibitorsKind ? a.exhibitorsKind : null,
    foodTruck: !!a.foodTruck,
    stageSqm: a.stage ? parseFloat(a.stageSqm) : null,
    street: a.street ? Object.fromEntries(streetOn(a).map((s) => [s.label, parseInt(a.streetCounts[s.label])])) : {},
    audioPeople: a.audio ? parseInt(a.audioPeople) : null,
    lightsSize: a.lights && a.lightsSize ? a.lightsSize : null,
    musicians: a.musicians ? a.musicianKinds : [],
    theatre: a.theatre ? a.theatreKinds : [],
    theatreOther: a.theatre && a.theatreKinds.includes("Altro") ? a.theatreOther.trim() || null : null,
    kids: a.kids ? a.kidsKinds : [],
    notes: Object.fromEntries(Object.entries(a.notes).filter(([k, v]) => v.trim() && a[k] !== false).map(([k, v]) => [k, v.trim()])),
    comedy: !!a.comedy, dj: !!a.dj, photographer: !!a.photographer, videomaker: !!a.videomaker,
    attachment: a.plan ? a.attachment?.url || null : null,
    other: a.other.trim() || null,
  };
}

const yn = (v) => (v ? "Sì" : "No");
const withNote = (v, n) => (n ? `${v === "No" ? "Sì" : v} · Note: ${n}` : v);

export function briefRows(p) {
  const b = p.brief || {};
  const n = b.notes || {};
  const d = p.dateTo && p.dateTo !== p.date ? `dal ${itDate(p.date)} al ${itDate(p.dateTo)}` : itDate(p.date);
  return [
    ["Tipo di evento", p.eventType + (b.eventTypeDetail ? ` (${b.eventTypeDetail})` : "")],
    ["Dove", [p.place, b.venue].filter(Boolean).join(" · ")],
    ["Quando", d],
    ["Stand", withNote(b.stands ? `${b.stands.count} stand${b.stands.sizes.length ? ` · misure ${b.stands.sizes.join(", ")}` : ""}` : "No", n.stands)],
    ["Espositori", withNote(b.exhibitors ? EXHIBITORS[b.exhibitors] : "No", n.exhibitors)],
    ["Food truck", yn(b.foodTruck)],
    ["Palco/pedana", b.stageSqm ? `${b.stageSqm} m²` : "No"],
    ["Artisti di strada/circensi", withNote(Object.keys(b.street || {}).length ? Object.entries(b.street).map(([k, c]) => `${k} ×${c}`).join(", ") : "No", n.street)],
    ["Intrattenimento bambini", withNote(b.kids?.length ? b.kids.join(", ") : "No", n.kids)],
    ["Service audio", b.audioPeople ? `Sì · circa ${b.audioPeople} persone` : "No"],
    ["Service luci", withNote(b.lightsSize ? `Sì · evento ${SIZES[b.lightsSize].toLowerCase()}` : "No", n.lights)],
    ["Musicisti", withNote(b.musicians?.length ? b.musicians.join(", ") : "No", n.musicians)],
    ["Compagnie teatrali", withNote(b.theatre?.length ? b.theatre.map((t) => (t === "Altro" && b.theatreOther ? b.theatreOther : t)).join(", ") : "No", n.theatre)],
    ["Cabarettista/gruppo comico", yn(b.comedy)],
    ["DJ", yn(b.dj)],
    ["Fotografo", yn(b.photographer)],
    ["Videomaker", yn(b.videomaker)],
    ["Piantina o foto dello spazio", b.attachment ? "Allegata" : "No"],
    ["Altri artisti o fornitori", b.other || "—"],
  ];
}
